var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "base-alert d-flex align-start rounded-sm",
      style: {
        backgroundColor: _setup.currentColors.background,
        borderLeftColor: _setup.currentColors.border,
      },
      attrs: { "data-qa-base": "base-alert" },
    },
    [
      _vm.icon
        ? _c("div", {
            staticClass: "base-alert__icon",
            class: _vm.icon,
            style: { color: _setup.currentColors.icon },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "base-alert__content py-2 pl-2 pr-4",
          attrs: { "data-qa": "base-alert-content" },
        },
        [
          _vm.title
            ? _c(
                "div",
                {
                  staticClass: "text-subtitle-2 text--text",
                  attrs: { "data-qa": "base-alert-title" },
                },
                [_vm._v("\n      " + _vm._s(_vm.title) + "\n    ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.text || _vm.$slots.default
            ? _c(
                "div",
                {
                  staticClass: "text-body-2 text--text",
                  attrs: { "data-qa": "base-alert-text" },
                },
                [
                  _vm._v("\n      " + _vm._s(_vm.text) + "\n      "),
                  _vm._t("default"),
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.linkText
            ? [
                _vm.href
                  ? _c(
                      "a",
                      {
                        staticClass:
                          "text-link-2 primary--text cursor-pointer link-decoration-underline",
                        attrs: {
                          "data-qa": "base-alert-link",
                          target: "_blank",
                          rel: "noopener noreferrer",
                          href: _vm.href,
                        },
                        on: {
                          click: function ($event) {
                            return _setup.emit("click:link")
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.linkText))]
                    )
                  : _c(
                      "button",
                      {
                        staticClass:
                          "text-link-2 primary--text cursor-pointer link-decoration-underline",
                        attrs: { "data-qa": "base-alert-link", type: "button" },
                        on: {
                          click: function ($event) {
                            return _setup.emit("click:link")
                          },
                        },
                      },
                      [_vm._v("\n        " + _vm._s(_vm.linkText) + "\n      ")]
                    ),
              ]
            : _vm._e(),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }